import api from "./api";

const UserRoleAPI = {
    getRolesByUser: (userId) => api.get(`/user-roles/user/${userId}`),
    assignUserRole: (data) => api.post(`/admin/user-roles/update-user-roles`, data),
    createAdmin: (data) => api.post(`/admin/user-roles/create-admin`, data),
    sendCreationCode: (data) => api.post(`/admin/user-roles/send-creation-code`, data),
    createUserWithCode: (data) => api.post(`/admin/user-roles/create-user-with-code`, data)
};

export default UserRoleAPI;
